import { render } from "./WeightMeasurement.vue?vue&type=template&id=2ad14b6a"
import script from "./WeightMeasurement.vue?vue&type=script&lang=ts"
export * from "./WeightMeasurement.vue?vue&type=script&lang=ts"
script.render = render

export default script